import * as z from 'zod';

export type SubscriptionItemFormSchemaValues = z.infer<typeof subscriptionItemFormSchema>;
export const subscriptionItemFormSchema = z.object({
    start_date: z.string(),
    end_date: z.string().optional(),
    service_plan_item: z.string().nonempty(),
    is_active: z.boolean(),
});
